import React from 'react';
import { InputNumber } from 'primereact/inputnumber';
import InputWrapper from './InputWrapper';

const PrimeInputNumber = ({ value, onChange, placeholder, label, error }) => {
  return (
    <InputWrapper label={label} error={error}>
      <InputNumber className="w-100" value={value} onValueChange={onChange} placeholder={placeholder} useGrouping={false} />
    </InputWrapper>
  );
};

export default PrimeInputNumber;